import { restPost } from "./RestClient";

export async function FetchCampaignAds(data) {
    const res = await restPost(`Ads_Clients/FetchCampaignAds`, data);
    return res.data;
}
export async function saveCampaignAd(data) {
    const res = await restPost(`Ads_Clients/saveCampaignAd`, data);
    return res.data;
}